(function(module) {
    'use strict';
    
    module.filter('brochureNames', function() {
        return function(brochures) {
            return brochures.map(function(brochure) {
                return brochure.title;
            });
        };
    });
})(angular.module('vhols'));